@import 'styles/mixins';
@import 'styles/blaze/mixins';
@import 'styles/variables';

.messagesContainer {
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
}

.messages {
  display: flex;
  flex-direction: column;
  gap: 30px;
  padding: 20px;
  overflow-x: hidden;

  [data-autopilot-system-redesign='on'] & {
    padding: 15px 15px 20px 15px;
  }

  [data-nextgen-chat='on'] & {
    padding: 12px 20px 40px 20px;
    gap: 40px;
  }
}

.loadingContainer {
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: 30px;
  padding: 0 20px;

  .infiniteLoader {
    display: flex;
    justify-content: center;
    align-items: center;
  }
}

.loadingMessage {
  display: flex;
  flex-direction: column;
  gap: 5px;

  &.user {
    align-self: flex-end;
    width: 80%;
    padding: 9px 11px;
    background-color: var(--dark-4);
    border-radius: 10px;
  }
}

.suggestions {
  display: flex;
  flex-wrap: wrap;
  gap: 5px;

  .suggestionPill {
    cursor: pointer;
    display: flex;
    align-items: center;
    gap: 5px;
    font-family: Sohne;
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 110%;
    letter-spacing: 0.28px;
    outline: none;

    &.hovered {
      filter: brightness(0.8);
    }
  }
}

.suggestionButton {
  background: var(--dark-3);
}

.nextGenSuggestions {
  display: flex;
  flex-direction: column;
  gap: 40px;
}

.nextGenSuggestionsHeader {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.nextGenList {
  display: block;
  padding-left: 24px;
  margin: 0;

  li {
    display: list-item;
    list-style-type: decimal;
    line-height: 1.6;
    margin-bottom: 6px;

    &:last-child {
      margin-bottom: 0;
    }
  }

  strong {
    font-weight: 500;
  }
}
